var SearchObject = /** @class */ (function () {
    function SearchObject() {
        this.WhatText = '';
        this.WhereText = '';
        this.WhenIndex = 5;
        this.CalendarDisplay = true;
        this.CouncilID = 0;
        this.KeyWords = '';
        this.IncludeDeletedAndUnpublished = false;
    }
    return SearchObject;
}());
var Calendars;
(function (Calendars) {
    function buildSearch(uniqueEvents) {
        var search = new SearchObject();
        search.UniqueEvents = uniqueEvents;
        search.IncludeDeletedAndUnpublished = false;
        return search;
    }
    function InitListingCalendar(calendarSelector, firstDate, organisationId, outletId, outletServiceId, loadingCallback, loadedCallback, includeExpiredEvents, includeEventsRunAtLocation, inDashboard, limit, additionalPath) {
        var oneMonthAgo = new Date();
        if (!(inDashboard || false)) {
            oneMonthAgo.setHours(0, 0, 0, 0);
            oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);
        }
        window.CalendarSearch = buildSearch(false);
        window.CalendarSearch.SearchOutletID = outletId;
        window.CalendarSearch.SearchOutletServiceID = outletServiceId;
        window.CalendarSearch.SearchOrganisationID = organisationId;
        window.CalendarSearch.IncludeExpiredEvents = includeExpiredEvents;
        window.CalendarSearch.IncludeEventsRunAtLocation = includeEventsRunAtLocation;
        var editsAllowed = inDashboard || false;
        if ((limit || 0)) {
            window.CalendarSearch.PageNo = 1;
            window.CalendarSearch.PageSize = limit;
        }
        $(calendarSelector).fullCalendar({
            header: {
                left: "prev,next today",
                center: "title",
                right: "month,agendaWeek,agendaDay"
            },
            height: "auto",
            startParam: "SearchFrom",
            endParam: "SearchTo",
            nowIndicator: true,
            fixedWeekCount: false,
            defaultDate: firstDate,
            events: {
                url: window.AppSettings.ApiUrl + "/api/v1/search/diary/GetInstanceResults",
                data: function () {
                    return window.CalendarSearch;
                }
            },
            eventDataTransform: function (event) {
                var eventDisplayColour = "#DCDCDC";
                switch (event.DiaryTypeID) {
                    case 1:
                        eventDisplayColour = "#4169E1";
                        break;
                    case 2:
                        eventDisplayColour = "#D2691E";
                        break;
                    case 3:
                        eventDisplayColour = "#2E8B57";
                        break;
                    case 4:
                        eventDisplayColour = "#BA55D3";
                        break;
                    case 5:
                        eventDisplayColour = "#2D585E";
                        break;
                }
                return {
                    id: event.ID,
                    title: event.EventName,
                    start: event.StartsAt,
                    end: event.EndsAt,
                    allDay: event.IsAllDay,
                    diaryElement: event,
                    color: eventDisplayColour,
                    canEdit: editsAllowed && event.CanEditOutlet
                };
            },
            eventRender: function (event, element) {
                var template = $("#diaryResultTemplate").render(event.diaryElement).replace("col-xs-6 col-sm-6 col-md-4 col-lg-3", "result-card-tip");
                var $template = $("<div/>").html(template);
                $(".nofollow", $template).removeAttr("rel");
                template = $template.html();
                element.qtip({
                    content: template,
                    position: {
                        target: "mouse",
                        adjust: { x: -5, y: -5 },
                        my: "bottom right",
                        at: "top left"
                    },
                    style: "qtip-light qtip-rounded"
                });
                element.addClass("edit");
                if (editsAllowed && event.canEdit) {
                    var $a = $("<a>")
                        .addClass("fc-view-link")
                        .attr("href", window.AppSettings.DiaryUrl + event.diaryElement.InstanceUrl)
                        .attr("target", "_blank")
                        .html("<i class='fa fa-eye'></i>");
                    element.append($a);
                    if (event.canEdit) {
                        var path = additionalPath != null ? additionalPath : "";
                        var $b = $("<a>")
                            .addClass("fc-edit-link")
                            .attr("href", "/Manage/Events/Edit/" + event.diaryElement.EventID + path + "#all")
                            .html("<i class='fa fa-edit'></i>");
                        element.append($b);
                    }
                }
                else {
                    element.attr("href", window.AppSettings.DiaryUrl + event.diaryElement.InstanceUrl);
                    element.attr("target", "_blank");
                }
                if (event.allDay) {
                    element.attr("aria-label", "All day event " + event.title + " on " + event.start.format("dddd, MMMM D YYYY"));
                }
                else {
                    if (!event.end) {
                        event.end = event.start;
                    }
                    element.attr("aria-label", "Event " + event.title + " on " + event.start.format("dddd, MMMM D YYYY") + " \n                                                starting at " + (event.start.minutes() === 0 ? event.start.format("h A") : event.start.format("h m A")) + " \n                                                and finishing at " + (event.end.minutes() === 0 ? event.end.format("h A") : event.end.format("h m A")));
                }
            },
            eventAfterAllRender: function () {
                $(".council-details").css({ "height": $(".council-details").next().height() });
                $(calendarSelector).attr("aria-label", $(".fc-event-container").length + " visible events");
            },
            loading: function (isLoading) {
                if (isLoading) {
                    $("#spinner").show();
                    if (typeof loadingCallback !== "undefined") {
                        loadingCallback();
                    }
                }
                else {
                    $("#spinner").hide();
                    $(".council-details").css({ "height": $(".council-details").next().height() });
                    if (typeof loadedCallback !== "undefined") {
                        loadedCallback();
                    }
                }
            },
            viewRender: function (view) {
                if (inDashboard || false) {
                    return true;
                }
                if (view.start <= oneMonthAgo) {
                    $(calendarSelector + " .fc-prev-button").addClass("fc-state-disabled");
                }
                else {
                    $(calendarSelector + " .fc-prev-button").removeClass("fc-state-disabled");
                }
                $("#eventCalendar .fc-prev-button").attr("aria-label", "Go to previous " + view.intervalUnit);
                $("#eventCalendar .fc-next-button").attr("aria-label", "Go to next " + view.intervalUnit);
                return true;
            }
        });
        $(".card-description").shave(46);
        $(".fc-title").shave(20);
    }
    Calendars.InitListingCalendar = InitListingCalendar;
})(Calendars || (Calendars = {}));
